type HintType = { hint: string }


const Hint = ({ hint }: HintType) => (
    <button
        className="bg-white rounded-lg text-blue-900 w-4 text-sm ml-2"
        onClick={(e) => {
            e.preventDefault();
            alert(hint);
        }}
    >
        ?
    </button>
);

export default Hint;